import React, { useRef, useContext } from "react";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { Form } from "react-router-dom";
import AppContext from "../../store/app-context";

import styles from "./QuoteSearchForm.module.css";

const QuoteSearchForm = (props) => {
  const appCtx = useContext(AppContext);

  let label_searchQuotes = 'Search Quotes';
  let label_quoteId = 'Quote ID';
  let label_webRefNum = 'Web Reference Number';
  let label_quoteExpStart = 'Quote Expiry Date Range Start';
  let label_quoteExpEnd = 'Quote Expiry Date Range End';
  let label_staus = 'Status';
  let label_anyStatus = 'Any Status';
  let label_ready = 'Ready';
  let label_submitted = 'Submitted';
  let label_review = 'In Review';
  let label_notSubmitted = 'Not Submitted';
  let label_expired = 'Expired';
  let label_findQuote = 'Find Quote';
  let label_no_result = 'No Results matching selected criteria, please refine.';

  if(appCtx && appCtx.bioradResources){
    label_searchQuotes = appCtx.bioradResources.Search_Quotes ? appCtx.bioradResources.Search_Quotes : 'Search Quotes';
    label_quoteId = appCtx.bioradResources.QuoteID ? appCtx.bioradResources.QuoteID : 'Quote ID';
    label_webRefNum = appCtx.bioradResources.Order_Web_Reference ? appCtx.bioradResources.Order_Web_Reference : 'Web Reference Number';
    label_quoteExpStart = appCtx.bioradResources.Quote_Exp_Start ? appCtx.bioradResources.Quote_Exp_Start : 'Quote Expiry Date Range Start';
    label_quoteExpEnd = appCtx.bioradResources.Quote_Exp_End ? appCtx.bioradResources.Quote_Exp_End : 'Quote Expiry Date Range End';
    label_staus = appCtx.bioradResources.Quote_Status ? appCtx.bioradResources.Quote_Status : 'Status';
    label_anyStatus = appCtx.bioradResources.Any_status ? appCtx.bioradResources.Any_status : 'Any Status';
    label_ready = appCtx.bioradResources.Ready ? appCtx.bioradResources.Ready : 'Ready';
    label_submitted = appCtx.bioradResources.Submitted ? appCtx.bioradResources.Submitted : 'Submitted';
    label_review = appCtx.bioradResources.In_Review ? appCtx.bioradResources.In_Review : 'In Review';
    label_notSubmitted = appCtx.bioradResources.Not_Submitted ? appCtx.bioradResources.Not_Submitted : 'Not Submitted';
    label_expired = appCtx.bioradResources.Expired ? appCtx.bioradResources.Expired : 'Expired';
    label_findQuote = appCtx.bioradResources.Find_Quote ? appCtx.bioradResources.Find_Quote : 'Find Quote'
    label_no_result = props.errorMsg && props.errorMsg === 'Quote_Search_No_Result' && appCtx.bioradResources.Quote_Search_No_Result ? appCtx.bioradResources.Quote_Search_No_Result : 'No Results matching selected criteria, please refine.';
  }

  const quoteIdRef = useRef();
  const webRefRef = useRef();
  const dateStartRef = useRef();
  const dateEndRef = useRef();
  const statusRef = useRef();

  const searchHandler = (event) => {
    event.preventDefault();
    props.onSearch({
      qid: quoteIdRef?.current?.value,
      webRef: webRefRef?.current?.value,
      dateStart: dateStartRef?.current?.value,
      dateEnd: dateEndRef?.current?.value,
      status: statusRef?.current?.value,
    }, true);
  };
  const currDate = new Date();
  currDate.setDate(currDate.getDate());
  var date = currDate.toISOString().substring(0, 10);
  return (
    <div className={styles.searchForm}>
      <div className={styles.serchForm__module}>
        <details className={styles.accordion}>
          <summary>
            <div>
              <h2 class="tier4">{label_searchQuotes}</h2>
            </div>
          </summary>
          <Form method="post" onSubmit={searchHandler}>
            <div className={styles.seachQuotesModule}>
              <div className={styles.quoteid_wrn}>
                <Input
                  ref={quoteIdRef}
                  label={label_quoteId}
                  className="styles.quoteID"
                  input={{
                    id: "quoteID",
                    type: "text",
                    name: "quoteID",
                  }}
                />
                <Input
                  ref={webRefRef}
                  label={label_webRefNum}
                  className="styles.webrn"
                  input={{
                    id: "refNumber",
                    type: "text",
                    name: "refNumber",
                  }}
                />
              </div>
              <div className={styles.dr_qs_button}>
                <div className={styles.dr_qs}>
                  <Input
                    ref={dateStartRef}
                    label={label_quoteExpStart}
                    className="styles.dateRng"
                    input={{
                      id: "dateS",
                      type: "date",
                      name: "dateS",
                    }}
                  />
                  <Input
                    ref={dateEndRef}
                    label={label_quoteExpEnd}
                    className="styles.dateRng"
                    input={{
                      id: "dateE",
                      type: "date",
                      name: "dateE",
                    }}
                  />
                </div>
                <div className={styles.webrn}>
                <div className={styles.quoteStatus}>
                    <label htmlFor="quoteStatus">{label_staus}</label>
                    <select id="quoteStatus" name="quoteStatus" ref={statusRef}>
                      <option value='-'>{label_anyStatus}</option>
                      <option value='Ready'>{label_ready}</option>
                      <option value='Submitted'>{label_submitted}</option>
                      <option value='In Review'>{label_review}</option>
                      <option value='Not Submitted'>{label_notSubmitted}</option>
                      <option value='Expired'>{label_expired}</option>
                    </select>
                  </div>
                  <Button type="submit" className={styles.findOrder}>
                    {label_findQuote}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
          {props.errorMsg && props.errorMsg.length > 0 && (
            <p className={styles.errormsg}>{label_no_result}</p>
          )}
        </details>
      </div>
    </div>
  );
};

export default QuoteSearchForm;
